import { createStore } from "zustand/vanilla";
import { createJSONStorage, persist } from "zustand/middleware";
import type { Location } from "@/types/inventory";

export type EVMiStoreState = {
  userId: string | null;
  businessUnit: string | null;
  locationId: string | null;
  location: Location | null;
  locationActiveTab: string | null;
  setLocationActiveTab: (locationActiveTab: string) => void;
  setBusinessUnit: (businessUnit: string) => void;
  setLocationId: (locationId: string) => void;
  setLocation: (location: Location | null) => void;
  clearEVMiStore: () => void;
  // Reset location/business-unit selections and stamp the store with the owning
  // user so the next user never inherits the previous user's persisted state.
  resetForUser: (userId: string) => void;
};

export const createEVMiStore = (initState?: Partial<EVMiStoreState>) => {
  return createStore<EVMiStoreState>()(
    persist(
      (set) => ({
        userId: null,
        businessUnit: null,
        locationId: null,
        location: null,
        ...initState,
        setBusinessUnit: (businessUnit: string) => set({ businessUnit }),
        setLocationId: (locationId: string) => set({ locationId }),
        setLocation: (location: Location | null) => set({ location }),
        clearEVMiStore: () =>
          set({
            userId: null,
            businessUnit: null,
            locationId: null,
            location: null
          }),
        resetForUser: (userId: string) =>
          set({
            userId,
            businessUnit: null,
            locationId: null,
            location: null,
            locationActiveTab: "products"
          }),
        locationActiveTab: "products",
        setLocationActiveTab: (locationActiveTab: string) =>
          set({ locationActiveTab })
      }),
      {
        name: "evmi-store",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
          userId: state.userId,
          businessUnit: state.businessUnit,
          locationId: state.locationId,
          location: state.location
        })
      }
    )
  );
};
